module.exports = __webpack_public_path__ + "static/img/header_bg.053ee91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/servitor/nmrj/header/header_bg.png
// module id = vwzn
// module chunks = 7